import { delay } from 'redux-saga'
import { call, put, takeLatest, select } from 'redux-saga/effects'
import {fetchContent} from "../api"
import {SEARCH_QUERY_CHANGED, FETCH_SEARCH_RESULTS_REQUEST, FETCH_SEARCH_RESULTS_SUCCESSFUL, FETCH_SEARCH_RESULTS_ERROR} from "../actions"
import {getSearchQuery, getExperimentRef} from "../selectors"
import {
    LOAD_MORE_SEARCH_RESULTS_ERROR, LOAD_MORE_SEARCH_RESULTS_REQUEST,
    LOAD_MORE_SEARCH_RESULTS_SUCCESSFUL
} from "../actions/search";

function* queryChanged(action) {
    if(!action.payload.executeSearch) return;
    // DEBOUNCE 500ms
    yield call(delay, 500)
    yield put({type: FETCH_SEARCH_RESULTS_REQUEST, payload: action.payload});
}

function* loadMore(action) {
    const query = yield select(getSearchQuery);
    const experimentRef = yield select(getExperimentRef);
    try {
        const queryString = {
            page: query.page + 1,
            page_size: query.page_size,
            q: query.query,
            tags: query.tags.join(','),
            categories: query.categories.join(','),
            gender: query.gender.join(','),
            ref: experimentRef.ref
        }
        const results = yield call(fetchContent, '/search', queryString);
        yield put({type: LOAD_MORE_SEARCH_RESULTS_SUCCESSFUL, payload: {...results}});
    } catch (e) {
        yield put({type: LOAD_MORE_SEARCH_RESULTS_ERROR, message: e.message});
    }
}

function* fetch(action) {
    try {
        const query = {
            page: 1,
            page_size: action.payload.page_size,
            q: action.payload.query,
            tags: action.payload.tags.join(','),
            categories: action.payload.categories.join(','),
            gender: action.payload.gender.join(','),
        }

        const results = yield call(fetchContent, '/search', query);
        yield put({type: FETCH_SEARCH_RESULTS_SUCCESSFUL, payload: {...results}});
    } catch (e) {
        yield put({type: FETCH_SEARCH_RESULTS_ERROR, message: e.message});
    }
}

function* searchSaga() {
    yield takeLatest(SEARCH_QUERY_CHANGED, queryChanged);
    yield takeLatest(FETCH_SEARCH_RESULTS_REQUEST, fetch);
    yield takeLatest(LOAD_MORE_SEARCH_RESULTS_REQUEST, loadMore);
}

export default searchSaga;


// WEBPACK FOOTER //
// ./src/sagas/search.js